import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import Moment from "moment";
import Settings from "../providers/settings.provider";
import Workload from "../model/workload.model";

export let Name = 'Workloads';

export class Workloads extends Service {
    static $name = Name;
    static $inject = ['$q', 'Restangular', 'settings'];

    create() {
        // NOOP.
    }

    inDateRange(startDate, endDate, combineBy, withResources) {
        combineBy = combineBy || 'day';
        withResources = withResources || false;

        var defer = this.$q.defer();

        startDate = Moment(startDate).format('YYYY-MM-DD');
        endDate = Moment(endDate).format('YYYY-MM-DD');

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('workload')
            .get({
                branchId: this.settings.branch.id,
                startDate: startDate,
                endDate: endDate,
                combineBy: combineBy,
                withResources: withResources
            })
            .then((data) => {
                var data = data.map((workloadData)=> {
                    return this.Restangular.copy(new Workload(workloadData));
                });

                defer.resolve(data);
            })
            .catch((response) => {
                defer.reject(response.data);
            });

        return defer.promise;
    }

}

var WorkloadsModule = Angular.module('workload-service', ['restangular', Settings.name]);

new Loader(WorkloadsModule)
    .load(Workloads);

export default WorkloadsModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/workload.service.js